import { render, staticRenderFns } from "./Pengiriman.vue?vue&type=template&id=2311e315&scoped=true"
import script from "./Pengiriman.vue?vue&type=script&lang=js"
export * from "./Pengiriman.vue?vue&type=script&lang=js"
import style0 from "./Pengiriman.vue?vue&type=style&index=0&id=2311e315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311e315",
  null
  
)

export default component.exports